import { Breakpoint, useMediaQuery, useTheme } from '@rhg/libs/material';

/**
 *
 * @param targetBreakpoint The breakpoint below which we consider the viewport to be mobile (default: 'md')
 * @returns
 */
export const useIsMobile = (targetBreakpoint: Breakpoint = 'md') => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down(targetBreakpoint));

    return isMobile;
};
